module.exports = __webpack_public_path__ + "static/media/audiometar.6f6b2128.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices/audiometar.jpg
// module id = 409
// module chunks = 0